<template>
<div class="view">
    <Header></Header>
    <div class="content-box">
        <div class="content">
            <router-view />
        </div>
    </div>
    <Footer></Footer>
    <floatBar></floatBar>
    <codeModal></codeModal>
    <enterModal />
</div>
</template>

<script>
import Header from '@/components/header/header.vue';
import Footer from '@/components/footer/footer.vue';
import codeModal from '@/components/modal/codeModal.vue';
import floatBar from '@/components/floatBar/floatBar.vue';
import enterModal from '@/components/modal/courseEnterModal.vue';
export default {
    data() {
        return {
            is_PC: this.$store.state.is_PC,
            is_wechat: this.$store.state.is_wechat,
            //滚轮是否超过180
            //用户信息
            user: '',
        }
    },
    components: {
        Header,
        Footer,
        codeModal,
        floatBar,
        enterModal,
    },

    computed: {
        //滚轮状态
        scrollType() {
            return this.$store.getters.getScrollType;
        },
    },
    created() {
        //判断登录设备
        // this.whatEquipment()
        // console.log(this.is_PC)

    },
    //进入页面执行的函数
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('scroll', this.onScroll)
        });
        this.getUser();
        // console.log(this.is_wechat)
    },
    methods: {
        //判断登录设备
        whatEquipment() {
            var userAgentInfo = navigator.userAgent;
            var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            this.is_PC = flag;
            this.$store.commit('is_PC', this.is_PC);
        },
        //滚轮缩小事件
        onScroll() {
            let scrolled = document.documentElement.scrollTop || document.body.scrollTop
            // console.log(scrolled)
            if (scrolled >= 180) {
                this.$store.commit('updateScrollType', true)
            } else {
                this.$store.commit('updateScrollType', false)
            }
        },
        //获取登录用户
        getUser() {
            let user = localStorage.getItem("user");

            if (user) {
                user = JSON.parse(user);
                this.$store.commit('update_login_user', user);
                this.$store.commit('updateIsLogin', true);
                // this.getUserData(user)
                // console.log(user)
            }
        },
        //获取用户资料更新用户资料
        getUserData(user) {
            let that = this;
            let UserID = user.UserID;
            let params = {
                UserID,
            };
            this.$store.dispatch('userData', params).then((response) => {
                let res = response;
                // console.log(response)
                if (res.statusText === 'OK' || res.status === 200) {
                    console.log(res.data)
                    //更新后的资料存到localStorage缓存区
                    localStorage.setItem("user", JSON.stringify(res.data));
                    //同时更新后的资料存到Vuex
                    that.$store.commit('update_login_user', res.data);
                } else {
                    this.$message.error(res.detail);
                }
            }).catch(err => {
                console.error(err);
                // this.$message.error("您当前网络有问题，请稍后再试。");
            });
        },
    },
}
</script>

<style scoped>

</style>
